import { Box, Button, Flex, Grid, GridItem, Image, Separator, Text } from "@chakra-ui/react";
import { useState } from "react";

const Opinions = ({ dataDevelopment, opinions }) => {
    const [showAll, setShowAll] = useState(false);

    return (
        <Box>
            <Grid templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)" }} gap={4}>
                <GridItem colSpan={1}>
                    <Text fontWeight="bold">Opiniones</Text>
                    <Box
                        borderWidth={1}
                        borderColor="#D9D9D9"
                        borderRadius="md"
                        mt={3}
                        p={5}
                        display="flex"
                        gap={6}
                    >
                        <Box>
                            <Text fontSize="2xs" mb={2}>
                                Desarrollador
                            </Text>
                            <Box
                                w="70px"
                                h="70px"
                                borderRadius="full"
                                borderWidth={1}
                                alignContent="center"
                                overflow="hidden"
                            >
                                <Image
                                    src={dataDevelopment?.extra_props?.logo_developer}
                                    alt="developer"
                                />
                            </Box>
                        </Box>
                        <Box minW="130px">
                            <Text fontWeight="bold">{opinions?.total_evaluations || "0"}</Text>
                            <Text fontSize="2xs" mb={2}>
                                Evaluaciones
                            </Text>
                            <Separator my={3} />
                            <Text fontWeight="bold">
                                {opinions?.raiting ? parseFloat(opinions?.raiting).toFixed(2) : ""}{" "}
                                ★
                            </Text>
                            <Text fontSize="2xs" mb={2}>
                                Calificación
                            </Text>
                        </Box>
                    </Box>
                </GridItem>

                <GridItem colSpan={2}>
                    <Box maxH="500px" overflow="hidden" overflowY="auto">
                        {opinions?.users_evaluations
                            ?.slice(0, showAll ? opinions?.users_evaluations.length : 2)
                            .map((user, idx) => (
                                <Box key={idx} mb={6}>
                                    <Flex gap={3} align="center">
                                        <Box
                                            w="60px"
                                            h="60px"
                                            borderWidth={1}
                                            borderColor="#D9D9D9"
                                            borderRadius="full"
                                            alignContent="center"
                                            justifyItems="center"
                                        >
                                            <Image
                                                src={
                                                    user?.profile_image ||
                                                    "https://media.grupoguia.mx/assets/icons/profile_icon.png"
                                                }
                                                alt="profile_image"
                                                w="45px"
                                                h="45px"
                                                borderRadius="full"
                                            />
                                        </Box>
                                        <Box>
                                            <Text fontWeight="bold" fontSize="sm">
                                                {user.user_name
                                                    .toLowerCase()
                                                    .split(" ")
                                                    .map(
                                                        (w) =>
                                                            w.charAt(0).toLocaleUpperCase("es-MX") +
                                                            w.slice(1)
                                                    )
                                                    .join(" ")}
                                            </Text>
                                            <Text fontSize="2xs">
                                                {user?.survey_date
                                                    ? new Date(user.survey_date)
                                                          .toLocaleDateString("es-MX", {
                                                              month: "long",
                                                              year: "numeric",
                                                          })
                                                          .replace(/^./, (str) => str.toUpperCase())
                                                    : ""}
                                            </Text>
                                        </Box>
                                    </Flex>
                                    <Text fontSize="xs" textAlign="justify" mt={2} px={1}>
                                        {user.comments}
                                    </Text>
                                </Box>
                            ))}
                    </Box>

                    {/* Botón Ver más */}
                    {opinions?.users_evaluations?.length > 2 && (
                        <Button
                            fontWeight={400}
                            size="sm"
                            variant="link"
                            color="#002B49"
                            mt={3}
                            onClick={() => setShowAll(!showAll)}
                        >
                            {showAll ? "Ver menos reseñas" : "Ver todas las reseñas >>"}
                        </Button>
                    )}
                </GridItem>
            </Grid>
            <Separator borderColor="#B1B1B1" mt={7} />
        </Box>
    );
};

export default Opinions;
